export default function SoundToggle({ muted, onToggle }) {
  return (
    <button
      className="sound-toggle"
      data-testid="sound-toggle-button"
      onClick={onToggle}
      aria-pressed={muted}
      aria-label={muted ? "Unmute sound" : "Mute sound"}
    >
      {muted ? "Sound off" : "Sound on"}
    </button>
  );
}
